import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as Logo } from "common/assets/icons/logo.svg";

import { ReactComponent as FilterIcon } from "common/assets/icons/filter.svg";

import { P } from "common/P/P";

import { Link, useLocation, useNavigate } from "react-router-dom";
import { routeConstants } from "navigation";
import ManagePanel from "common/ManagePanel/ManagePanel";
import { Htag } from "common/Htag/Htag";

import { ReactComponent as ArrowIconRight } from "common/assets/icons/chevron-right.svg";
import { ReactComponent as ArrowIconDown } from "common/assets/icons/chevron-down.svg";
import { ReactComponent as ResminamaIcon } from "common/assets/icons/file-text.svg";
import { ReactComponent as BuyruklarIcon } from "common/assets/icons/file-check.svg";
import { ReactComponent as ArhiwIcon } from "common/assets/icons/archive.svg";
import { ReactComponent as PointIcon } from "common/assets/icons/point.svg";
import { ReactComponent as ChatIcon } from "common/assets/icons/message.svg";
import { ReactComponent as HasabatIcon } from "common/assets/icons/page-edit.svg";
import { ReactComponent as ContextSearchIcon } from "common/assets/icons/contextSearch.svg";
import { ReactComponent as LogoutIcon } from "common/assets/icons/log-out.svg";
import { ReactComponent as FastLeftIcon } from "common/assets/icons/fast-arrow-left.svg";
import { ReactComponent as HamburgerMenuIcon } from "common/assets/icons/Hamburger.svg";
import { SearchInput } from "common/Search/Search";
import RadioButton from "common/RadioButton/RadioButton";
import { Input } from "common/Input/Input";
import DatePicker from "common/DatePicker/DatePicker";
import LogoutModal from "components/LogoutModal/LogoutModal";
import logoPicture from "common/assets/images/logo.png";
import { deleteCookie } from "utils/cookie";
import { serviceConfig } from "configs";

const SidebarData = [
	{
		id: 1,
		icon: <ResminamaIcon />,
		name: "Daşarky resminamalar",
		children: [
			{
				id: 1,
				name: "Gelenler",
				link: routeConstants.externalIncoming.route,
			},
			{
				id: 2,
				name: "Iberilenler",
				link: routeConstants.externalSending.route,
			},
			{
				id: 3,
				name: "Edara-ara",
				link: routeConstants.betweenCompany.route,
			},
		],
	},
	{
		id: 2,
		icon: <ResminamaIcon />,
		name: "Içerki resminamalar",
		children: [
			{
				id: 1,
				name: "Gelenler",
				link: routeConstants.internalIncoming.route,
			},
			{
				id: 2,
				name: "Iberilenler",
				link: routeConstants.internalSending.route,
			},
		],
	},
	{
		id: 3,
		icon: <BuyruklarIcon />,
		name: "Buýruklar",
		children: [
			{
				id: 1,
				name: "Buýruklar",
				link: routeConstants.commandments.route,
			},
			{
				id: 2,
				name: "Meniň buýruklarym",
				link: routeConstants.myCommandments.route,
			},
		],
	},
	{
		id: 4,
		icon: <ArhiwIcon />,
		name: "Faýl arhiwi",
		link: routeConstants.archieve.route,
		children: [],
	},
	{
		id: 5,
		icon: <ChatIcon />,
		name: "Çat",
		link: routeConstants.chat.route,
		children: [],
	},
	{
		id: 6,
		icon: <ArhiwIcon />,
		name: "Resminama arhiwi",
		children: [
			{
				id: 1,
				name: "Ýapylan daşky giren hatlar",
				link: routeConstants.documentArchiveClosedIncoming.route,
			},
			{
				id: 2,
				name: "Iberilen daşky hatlar",
				link: routeConstants.documentArchiveSendingExternal.route,
			},
			{
				id: 3,
				name: "Ýapylan içki iberilen hatlar",
				link: routeConstants.documentArchiveClosedSending.route,
			},
		],
	},
	// {
	// 	id: 7,
	// 	icon: <HasabatIcon />,
	// 	name: "Hasabat",
	// 	link: routeConstants.report.route,
	// 	children: [],
	// },
	{
		id: 9,
		icon: <FilterIcon />,
		name: "Giňeldilen filter",
		link: routeConstants.advancedFilter.route,
		children: [],
	},
	{
		id: 10,
		icon: <ContextSearchIcon />,
		name: "Kontekst gözleg",
		link: routeConstants.contextSearch.route,
		children: [],
	},
	{
		id: 11,
		icon: <ResminamaIcon />,
		name: "Ähli hatlar",
		link: routeConstants.allLetters.route,
		children: [],
	},
	{
		id: 8,
		icon: <LogoutIcon className="stroke-strokeColor" />,
		name: "Çykmak",
		link: routeConstants.logout.route,
		children: [],
	},
];

const Sidebar: React.FC = (): JSX.Element => {
	const [openItemId, setOpenItemId] = useState(null);

	const SidebarRef = useRef<HTMLDivElement | null>(null);
	const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);
	const location = useLocation();
	const navigate = useNavigate();

	const handleItemClick = (item: any) => {
		if (item.id === 8) {
			// If the clicked item is the logout button, open the LogoutModal
			openLogoutModal();
		}
		if (item.id === 5) {
			window.open(item.link, "_blank", "noopener,noreferrer");
		} else if (item.link) {
			// For other items with links, navigate to the link
			navigate(item.link);
			setOpenItemId(openItemId === item.id ? null : item.id);
		} else {
			// Toggle open/close for items without links
			setOpenItemId(openItemId === item.id ? null : item.id);
		}
	};
	const [isManagePanelOpen, setIsManagePanelOpen] = useState(false);

	const toggleManagePanel = () => {
		setIsManagePanelOpen(!isManagePanelOpen);
	};

	const isItemOpen = (id: any) => openItemId === id;
	const isRouteActive = (link: any) => location.pathname === link;

	const renderIcon = (icon: any, isOpen: boolean, item?: any) => {
		// Determine the class based on isOpen and the item's id
		let className = "";
		if (isOpen) {
			className = "stroke-white"; // Open items get stroke-white
			if (item?.id === 9) {
				className += " fill-white"; // Items with id 9 get fill-white additionally
			}
		}

		// Clone the icon element with updated props
		return React.cloneElement(icon, { className: className });
	};

	const openLogoutModal = () => setIsLogoutModalOpen(true);

	// Function to close the LogoutModal
	const handleCloseLogoutModal = () => setIsLogoutModalOpen(false);

	// Function to handle logout confirmation

	const handleLogout = () => {
		deleteCookie("accessToken");
		deleteCookie("username");
		localStorage.removeItem("user");
		// navigate("/login", { replace: true });
		// setIsLogoutModalOpen(false);
		window.location.reload();
	};

	const userString = localStorage.getItem("user");
	const user = userString ? JSON.parse(userString) : null;

	const filterSidebarData = () => {
		const userString = localStorage.getItem("user");
		const user = userString ? JSON.parse(userString) : null;
		const userTypeId = user ? user.user?.userTypeId?._id : null;
		const numericUserTypeId = parseInt(userTypeId);

		const parentToCheckId = 3; // Assuming "Buýruklar" has the parent ID of 3
		const childToHideId = 2; // ID of the child to hide

		return SidebarData.map((item) => {
			if (item.id === parentToCheckId) {
				// Check if the item is the specific parent item
				if (numericUserTypeId === 11 || numericUserTypeId === 1) {
					// Modify children for user types 11 and 1
					const updatedChildren = item.children.filter(
						(child) => child.id !== childToHideId
					);
					return { ...item, children: updatedChildren };
				}
			}

			// Hide "Resminama arhiwi" for user types other than 12, 7, 6
			if (
				item.name === "Resminama arhiwi" &&
				!(
					numericUserTypeId === 12 ||
					numericUserTypeId === 7 ||
					numericUserTypeId === 6
				)
			) {
				return null;
			}

			if (
				item.name === "Giňeldilen filter" &&
				!(
					numericUserTypeId === 12 ||
					numericUserTypeId === 11 ||
					numericUserTypeId === 6
				)
			) {
				return null;
			}

			if (
				item.name === "Kontekst gözleg" &&
				!(
					numericUserTypeId === 12 ||
					numericUserTypeId === 11 ||
					numericUserTypeId === 6
				)
			) {
				return null;
			}

			if (
				item.name === "Ähli hatlar" &&
				!(numericUserTypeId === 12 || numericUserTypeId === 6)
			) {
				return null;
			}

			return item;
		}).filter((item) => item !== null); // This removes any null items
	};

	// Use the function to get the filtered Sidebar data
	const filteredSidebarData = filterSidebarData();

	const [isSidebarOpen, setIsSidebarOpen] = useState(true);

	const toggleSidebar = () => {
		setIsSidebarOpen(!isSidebarOpen);
	};

	const sidebarClass = isSidebarOpen
		? "w-full transition-width duration-300" // Width when open (e.g., w-64 for 16rem width)
		: "w-[72px] transition-width duration-300"; // Width when closed (e.g., w-15 for 3.75rem width)

	return (
		<div
			className={`${sidebarClass} z-50 border-r border-strokeColor h-screen bg-lowOpacity`}
			ref={SidebarRef}
		>
			<div
				className={`grid py-4 px-6 grid-cols-1 place-content-between gap-8 bg-mainFirstColor items-center ${
					isSidebarOpen && "w-[270px]"
				}`}
			>
				<div
					className={`grid ${
						isSidebarOpen ? "grid-cols-frMax gap-2" : "grid-cols-1"
					}  place-items-center`}
				>
					{isSidebarOpen && (
						<Link to={routeConstants.root.route} className="place-self-start">
							{serviceConfig.digidocs_template === 1 ? (
								<div className="grid gap-2 grid-cols-maxTwo place-items-center">
									<Logo className="w-8 h-8" />
									<Htag
										tag="h1"
										type="semibold"
										className="text-3xl cursor-pointer text-mainColor"
									>
										Digidocs
									</Htag>
								</div>
							) : (
								<div className="grid gap-2 grid-cols-maxTwo place-items-center">
									<img src={logoPicture} alt="logo" className="w-10 h-10" />
									<Htag
										tag="h1"
										type="semibold"
										className="text-3xl cursor-pointer text-mainColor"
									>
										IMM
									</Htag>
								</div>
							)}
						</Link>
					)}

					{isSidebarOpen ? (
						<FastLeftIcon className="cursor-pointer" onClick={toggleSidebar} />
					) : (
						<HamburgerMenuIcon
							className="cursor-pointer stroke-mainColor"
							onClick={toggleSidebar}
						/>
					)}
				</div>
			</div>
			{isSidebarOpen && (
				<div
					className={`grid pt-4 px-4 grid-cols-1 gap-2 bg-mainFirstColor items-center`}
				>
					{filteredSidebarData.map((item: any) => (
						<React.Fragment key={item.id}>
							{/* Sidebar Item */}
							<div
								className={`grid gap-1 px-2 py-2 cursor-pointer grid-cols-maxThree place-items-center w-full ${
									isItemOpen(item.id) && "bg-mainGradient rounded-md"
								}`}
								onClick={() => handleItemClick(item)}
							>
								{renderIcon(item.icon, isItemOpen(item.id), item)}
								<P
									size="p3"
									type="regular"
									className={`cursor-pointer text-grayTwo ${
										isItemOpen(item.id) ? "text-white" : ""
									}`}
								>
									{item.name}
								</P>
								{item.id !== 5 &&
									item.id !== 8 &&
									(isItemOpen(item.id) ? (
										<ArrowIconDown className="stroke-white" />
									) : (
										<ArrowIconRight />
									))}
							</div>

							{/* Conditional Child Items */}
							{isItemOpen(item.id) && item.id !== 5 && item.id !== 8 && (
								<div className="grid grid-cols-1 ">
									{filteredSidebarData.map(
										(item: any) =>
											isItemOpen(item.id) &&
											item.id !== 5 &&
											item.id !== 8 && (
												<div key={item.id} className="grid grid-cols-1">
													{/* Conditional Components */}
													{item.id !== 5 && item.id !== 8 && (
														<div className="grid items-center grid-cols-1 gap-2">
															{/* {item.id !== 2 &&
								item.id !== 3 &&
								item.id !== 4 &&
								item.id !== 7 && (
									<div
										className="p-[10px] rounded-md bg-mainColor cursor-pointer"
										onClick={toggleManagePanel}
									>
										<FilterIcon />
									</div>
								)} */}
															{item.id === 7 && (
																<div className="w-full min-w-[290px]">
																	<DatePicker />
																</div>
															)}
														</div>
													)}
												</div>
											)
									)}

									{/* Child Items */}
									<div className="grid grid-flow-row gap-2 auto-rows-max">
										{item.children.map((child: any) => (
											<Link
												key={child.id}
												to={child.link}
												target={item.id === 5 ? "_blank" : "_self"}
												rel={item.id === 5 ? "noopener noreferrer" : undefined}
												className={`text-grayTwo hover:text-mainColor group py-2 px-4 rounded-md min-w-[168px] grid grid-cols-maxTwo gap-1 place-items-center ${
													isRouteActive(child.link) ? "text-mainColor" : ""
												}`}
											>
												<PointIcon
													className={`group-hover:stroke-mainColor ${
														isRouteActive(child.link)
															? "stroke-mainColor"
															: "stroke-grayTwo"
													}`}
												/>
												{child.name}
											</Link>
										))}
									</div>
								</div>
							)}
						</React.Fragment>
					))}
				</div>
			)}

			<ManagePanel
				isOpen={isManagePanelOpen}
				onClose={() => setIsManagePanelOpen(false)}
				label="Filter"
				onSubmit={() => console.log("Checkout clicked")}
				onCancel={() => console.log("Checkout clicked")}
			>
				<div className="grid grid-flow-row gap-4 grid-col-1 auto-rows-max">
					<div className="grid grid-flow-row grid-cols-1 gap-4 auto-rows-max">
						<P size="t1" type="regular">
							Resminamalaryň görnüşi
						</P>
						<div className="grid gap-6 grid-cols-maxThree">
							<RadioButton
								id="edara"
								name="edara"
								value=""
								label="Ählisi"
								onChange={() => console.log("HEllo")}
								checked={true}
							/>
							<RadioButton
								id="edara"
								name="edara"
								value=""
								label="Gelenler"
								onChange={() => console.log("HEllo")}
								checked={false}
							/>
							<RadioButton
								id="edara"
								name="edara"
								value=""
								label="Iberilenler"
								onChange={() => console.log("HEllo")}
								checked={false}
							/>
						</div>
					</div>
					<Input
						appearance="default"
						type="text"
						name="getting_id"
						withlabel={true}
						label="Giriş belgisi"
						value=""
						onChange={() => console.log("")}
					/>

					<DatePicker label="Giriş senesi" />
					<Input
						appearance="default"
						type="text"
						name="from"
						withlabel={true}
						label="Nireden"
						value=""
						onChange={() => console.log("")}
					/>
					<Input
						appearance="default"
						type="text"
						name="whom"
						withlabel={true}
						label="Kimden"
						value=""
						onChange={() => console.log("")}
					/>
				</div>
			</ManagePanel>
			<LogoutModal
				isOpen={isLogoutModalOpen}
				onClose={handleCloseLogoutModal}
				onConfirm={handleLogout}
				onCancel={handleCloseLogoutModal}
			/>
		</div>
	);
};

export default Sidebar;
